import script from "./MobileTab4.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileTab4.vue?vue&type=script&setup=true&lang=ts"

import "./MobileTab4.vue?vue&type=style&index=0&id=7b910c38&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b910c38"]])

export default __exports__